import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNil, isInt } from '@pct-ts/typeguard';

export function integerValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (isNil(value) || value === '') {
      return null;
    }

    if (!isInt(value)) {
      return { integer: true };
    }

    return null;
  };
}
